"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mutations = void 0;

var _slicedToArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));

var _constants = require("./constants");

var mutations = {
  SET_SELECTED_DRIVER: function SET_SELECTED_DRIVER(state, data) {
    state.selectedDriver = data || null;
  },
  SET_DISABLE_TRUCK_LIST: function SET_DISABLE_TRUCK_LIST(state, data) {
    state.disableTruckList = data || [];
  },
  SET_TRUCKS: function SET_TRUCKS(state, data) {
    state.trucks = data || [];
  },
  SET_BUFFER_TRUCKS: function SET_BUFFER_TRUCKS(state, data) {
    state.bufferTrucks = data || [];
  },
  SET_SELECTED_TRUCK: function SET_SELECTED_TRUCK(state, data) {
    state.selectedTruck = data || null;
  },
  SET_PAGINATION: function SET_PAGINATION(state, data) {
    state.pagination = data || _constants.DEFAULT_PAGINATION;
  },
  SET_DEFAULT_PAGINATION: function SET_DEFAULT_PAGINATION(state, data) {
    state.defaultPagination = data || _constants.DEFAULT_PAGINATION;
  },
  SET_DEFAULT_SIZE: function SET_DEFAULT_SIZE(state, data) {
    state.defaultTableSize = data || _constants.DEFAULT_PAGE_SIZE;
  },
  SET_DEFAULT_ORDER_COLUMNS: function SET_DEFAULT_ORDER_COLUMNS(state, data) {
    state.defaultOrderColumns = data || [];
  },
  SET_SELECTED_COLUMNS: function SET_SELECTED_COLUMNS(state, data) {
    state.selectedColumns = data || [];
  },
  SET_ORDER_COLUMNS: function SET_ORDER_COLUMNS(state, data) {
    state.orderColumns = data || '';
  },
  SET_ORDER_COLUMN_TEMPLATES: function SET_ORDER_COLUMN_TEMPLATES(state, data) {
    state.orderColumnTemplates = data || [];
  },
  SET_UNASSIGNED_ORDERS: function SET_UNASSIGNED_ORDERS(state, data) {
    state.unassignedOrders = data || [];
  },
  SET_EXCLUDED_ORDERS: function SET_EXCLUDED_ORDERS(state, data) {
    state.excludedOrders = data || [];
  },
  SET_INCLUDED_ORDERS: function SET_INCLUDED_ORDERS(state, data) {
    state.includedOrders = data || [];
  },
  SET_SELECTED_ORDERS: function SET_SELECTED_ORDERS(state, data) {
    state.selectedOrders = data || [];
  },
  SET_ORDER_FILTERS: function SET_ORDER_FILTERS(state, data) {
    state.orderFilters = data || [];
  },
  SET_INCIDENTS: function SET_INCIDENTS(state, data) {
    state.incidents = data || [];
  },
  SET_DATE_RANGE_OPTION: function SET_DATE_RANGE_OPTION(state, data) {
    state.dateRangeOption = data;
  },
  SET_START_DATE: function SET_START_DATE(state, data) {
    state.startDate = data;
  },
  SET_END_DATE: function SET_END_DATE(state, data) {
    state.endDate = data;
  },
  SET_PLAN_DATE: function SET_PLAN_DATE(state, data) {
    state.planDate = data;
  },
  SET_CORE_INFORMATION: function SET_CORE_INFORMATION(state, data) {
    var _data = (0, _slicedToArray2.default)(data, 1),
        orderColumnTemplates = _data[0];

    state.orderColumnTemplates = orderColumnTemplates && orderColumnTemplates['data'] && orderColumnTemplates['data']['settings'] ? orderColumnTemplates['data']['settings'] : [];
  },
  SET_TABLE_LOADING: function SET_TABLE_LOADING(state, data) {
    state.tableLoading = data;
  },
  SET_PLAN: function SET_PLAN(state, data) {
    state.plan = data && data['data'] && data['data']['data'] ? data['data']['data'] : data;
  },
  SET_ANY_CHANGES: function SET_ANY_CHANGES(state, data) {
    state.anyChanges = data;
  },
  SET_PLAN_EXISTS: function SET_PLAN_EXISTS(state, data) {
    state.isPlanExists = data;
  },
  SET_LOCATION_TYPE: function SET_LOCATION_TYPE(state, data) {
    state.locationType = data;
  },
  SET_ORDER_LOCATION_LISTS: function SET_ORDER_LOCATION_LISTS(state, data) {
    state.orderLocationLists = data;
  },
  SET_SELECTED_LOCATION: function SET_SELECTED_LOCATION(state, data) {
    state.selectedLocation = data;
  },
  SET_TRUCK_FILTERS: function SET_TRUCK_FILTERS(state, data) {
    state.truckFilters = data || [];
  },
  SET_TRUCK_LOADING: function SET_TRUCK_LOADING(state, data) {
    state.truckLoading = data;
  },
  SET_SEARCH_TYPE: function SET_SEARCH_TYPE(state, data) {
    state.searchType = data;
  },
  SET_TO_BE_UNASSIGNED_ORDER_IDS: function SET_TO_BE_UNASSIGNED_ORDER_IDS(state, data) {
    state.toBeUnassignedOrderIds = data;
  },
  SET_FAILED_ORDERS: function SET_FAILED_ORDERS(state, data) {
    state.failedOrders = data;
  },
  SET_MANUAL_ASSIGN_LOADING: function SET_MANUAL_ASSIGN_LOADING(state, data) {
    state.isManualAssignLoading = data;
  },
  SET_AUTO_ASSIGN_LOADING: function SET_AUTO_ASSIGN_LOADING(state, data) {
    state.isAutoAssignLoading = data;
  },
  SET_ASSIGNED_DRIVER_CHANGES: function SET_ASSIGNED_DRIVER_CHANGES(state, data) {
    state.isAssignedDriverChanges = data;
  },
  SET_GLOBAL_ACTIVE_USERS: function SET_GLOBAL_ACTIVE_USERS(state, data) {
    state.GLOBAL_ACTIVE_USERS = data;
  },
  SET_GLOBAL_SELECTED_ORDERS: function SET_GLOBAL_SELECTED_ORDERS(state, data) {
    state.GLOBAL_SELECTED_ORDERS = data;
  },
  SET_GLOBAL_SELECTED_TRUCKS: function SET_GLOBAL_SELECTED_TRUCKS(state, data) {
    state.GLOBAL_SELECTED_TRUCKS = data;
  },
  SET_IS_OCCUPIED: function SET_IS_OCCUPIED(state, data) {
    state.isOccupied = data;
  },
  SET_OCCUPYING_USERNAME: function SET_OCCUPYING_USERNAME(state, data) {
    state.occupyingUsername = data;
  },
  SET_OCCUPYING_ROUTE: function SET_OCCUPYING_ROUTE(state, data) {
    state.occupyingRoute = data;
  },
  SET_REMOVED_TRUCK_IDS: function SET_REMOVED_TRUCK_IDS(state, data) {
    state.removedTruckIds = data || [];
  },
  SET_PICK_UP_ALL_FIRST: function SET_PICK_UP_ALL_FIRST(state, data) {
    state.pickUpAllFirst = data;
  },
  SET_TIMEWINDOW_PRIORITY: function SET_TIMEWINDOW_PRIORITY(state, data) {
    state.timeWindowPriority = data;
  },
  SET_TIMEWINDOW_BUFFER: function SET_TIMEWINDOW_BUFFER(state, data) {
    state.timeWindowBuffer = data;
  },
  SET_ADJUST_ETA: function SET_ADJUST_ETA(state, data) {
    state.adjustETA = data;
  },
  SET_CURR_TRUCK_PLAN_ID: function SET_CURR_TRUCK_PLAN_ID(state, data) {
    state.currTruckPlanId = data;
  },
  SET_IS_ENABLE_ALL_TRUCKS: function SET_IS_ENABLE_ALL_TRUCKS(state, data) {
    state.isEnableAllTrucks = data;
  }
};
exports.mutations = mutations;